module.exports = __webpack_public_path__ + "img/nav-vehicle-models-homepage-chevy.ba183e45.png";